import axios from 'axios'

import * as types from '../mutation-types'
import { createTheParametersOfTheUrl } from '../../plugins/helper'

export const state = {
  loadingDepartamentsEntry: true,
  departamentsEntry: [],
  errorDepartamentsEntry: null,
}

const doToArrayObject = data => {
  const term = []
  let temp = null
  const datos = data
  Object.keys(datos).forEach(index => {
    temp = datos[index]
    term.push({ value: temp.id, text: temp.nombre })
  })

  return term
}

export const mutations = {
  [types.GET_DEPARTMENTS_ENTRY_START](state) {
    state.loadingDepartamentsEntry = true
    state.departamentsEntry = []
    state.errorDepartamentsEntry = null
  },

  [types.GET_DEPARTMENTS_ENTRY_SUCCESS](state, { data }) {
    state.loadingDepartamentsEntry = false
    state.departamentsEntry = doToArrayObject(data)
    state.errorDepartamentsEntry = null
  },

  [types.GET_DEPARTMENTS_ENTRY_ERROR](state, { error }) {
    state.loadingDepartamentsEntry = false
    state.departamentsEntry = []
    state.errorDepartamentsEntry = error
  },
}

export const actions = {
  async getDepartamentsEntry({ commit }, payload) {
    try {
      commit(types.GET_DEPARTMENTS_ENTRY_START)

      const href = createTheParametersOfTheUrl(payload)

      const { data } = await axios.get(`/api/ticket/departments/list${href}`)

      commit(types.GET_DEPARTMENTS_ENTRY_SUCCESS, { data })
    } catch (e) {
      commit(types.GET_DEPARTMENTS_ENTRY_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  loadingDepartamentsEntry: state => state.loadingDepartamentsEntry,
  departamentsEntry: state => state.departamentsEntry,
  errorDepartamentsEntry: state => state.errorDepartamentsEntry,
}
